import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { createMigrate, persistReducer } from 'redux-persist';
import recovery from './recovery.reducer';
import {
  setLocalStorageAccessToken,
  setLocalStorageExpirationToken,
  setLocalStorageRefreshToken,
} from '~/Hooks/useLocalStorage';

export const authReducer = combineReducers({ recovery });

const migrations = {
  2: (state: any) => {
    setLocalStorageAccessToken(state?.login?.access_token);
    setLocalStorageExpirationToken(
      parseInt(state?.login?.expires_in, 10) * 1000 + new Date().getTime(),
    );
    setLocalStorageRefreshToken(state?.login?.refresh_token);
    return state;
  },
};

const languageReducerPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['recovery'],
  version: 2,
  migrate: createMigrate(migrations, { debug: true }),
};

export default persistReducer(languageReducerPersistConfig, authReducer);
